import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.video-proxy').on('click', (e) => {
        const $this = $(this);
        e.preventDefault();
        const $target = $($this.attr('href')).find('[data-video-id]');
        $target.trigger('click');
    });
});
